import { useState } from "react";
import { ChevronDown, Shield, FileText } from "lucide-react";
import { useCmsContent, renderMarkers } from "@/lib/cms";
import { CMS_FALLBACK } from "@/lib/cmsDefaults";

export default function PoliciesPage() {
  const { c } = useCmsContent("policies");
  const cmsSections = c["policies.sections"] || [];
  const fallback = CMS_FALLBACK?.policies?.["policies.sections"] || [];
  // Merge: keep CMS-published sections, but PREPEND any fallback section whose
  // title isn't already present. This ensures the Subscription FAQ (and other
  // critical defaults) are always visible even if the parent's CMS draft
  // hasn't been updated to include them.
  const cmsTitles = new Set(cmsSections.map((s) => (s.title || "").toLowerCase()));
  const missingDefaults = fallback.filter((s) => !cmsTitles.has((s.title || "").toLowerCase()));
  const sections = [...missingDefaults, ...cmsSections];
  const [open, setOpen] = useState(null);
  const [query, setQuery] = useState("");

  const filtered = sections.filter((s) => {
    if (!query) return true;
    const q = query.toLowerCase();
    const t = (s.title || "").toLowerCase();
    return t.includes(q) || (s.bullets || []).some((b) => (b || "").toLowerCase().includes(q));
  });

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-center gap-2 mb-2">
        <Shield className="text-green-700" strokeWidth={2.5}/>
        <h1 className="font-fredoka text-3xl sm:text-4xl font-bold text-slate-900" data-testid="policies-title">{c["policies.title"]}</h1>
      </div>
      <p className="text-slate-600 mb-4">{c["policies.subtitle"]}</p>
      <input
        className="input-clay h-11 px-3 w-full mb-4"
        placeholder="Search policies…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        data-testid="policies-search"
      />

      <div className="space-y-2" data-testid="policies-list">
        {filtered.map((s, i) => {
          const k = s.title;
          return (
            <div key={k + i} className="card-clay overflow-hidden">
              <button
                onClick={() => setOpen(open === k ? null : k)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
                data-testid={`policy-toggle-${i}`}
              >
                <span className="font-fredoka font-bold text-slate-900 flex items-center gap-2"><FileText size={16} className="text-green-600"/>{i + 1}. {s.title}</span>
                <ChevronDown className={`transition-transform ${open === k ? "rotate-180" : ""}`}/>
              </button>
              {open === k && (
                <div className="px-5 pb-4 text-sm text-slate-700 space-y-2" data-testid={`policy-body-${i}`}>
                  {(s.bullets || []).map((b, idx) => (
                    <div key={idx} className="flex gap-2"><span className="text-green-600">•</span><span dangerouslySetInnerHTML={{ __html: renderMarkers(b) }}/></div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
        {filtered.length === 0 && <div className="card-clay p-8 text-center text-slate-400">No matches.</div>}
      </div>
    </div>
  );
}
